export enum BotCategoryEnum {
  AI_BASED_CHATBOT = "AIKitty",
  SCENARIO_BASED_CHATBOT = "McBotFace"
}
